
const NextIcon: React.FC = () => (
	// <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#5f6368">
	// 	<path d="M684.16-454.87H180v-50.26h504.16L444.67-744.61 480-780l300 300-300 300-35.33-35.39 239.49-239.48Z"/>
	// </svg>
<svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9">
	<g id="Group_1131" data-name="Group 1131" transform="translate(-255 -775.5)">
	<g id="Group_876" data-name="Group 876" transform="translate(-354 1145.5) rotate(-90)">
	<path id="Path_717" data-name="Path 717" d="M4.5,2,9,8H0Z" transform="translate(370 617) rotate(180)" fill="white"/>
	</g>
</g>
</svg>
);

export default NextIcon;
